import { mount } from "@vue/test-utils";
import BranchOfficesOld from "@/components/core/composite/combos/BranchOfficesOld";

describe("BranchOfficesOld component", () => {
  let wrapper;

  const props = {
    placeholder: "placeHolderValue",
    label: "labelValue",
    value: "propValue",
    subhint: "subHintValue",
    validationError: "",
    items: "itemsValue",
    inputMode: "inputMode"
  };

  beforeEach(() => {
    wrapper = mount(BranchOfficesOld, {
      propsData: props
    });
  });

  it("Renders del component BranchOfficesOld", () => {
    expect(wrapper).toBeDefined();
  });
});
